











import { Component, Watch, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CommonAccordion extends Vue {
  @Prop({default: false, type: Boolean}) static!: boolean
  @Prop({default: 0, type: Number}) itemIndex!: number
  @Prop({default: 0, type: Number}) activeItem!: number
  
  active = false
  
  $refs!: {
    content: HTMLDivElement
  }
  handlerClickHeader():void {
    if (this.static) {
      return
    }
    this.active = !this.active
    const ref = this.$refs.content
    ref.style.maxHeight && ref.style.maxHeight !== '0px' ? ref.style.maxHeight = '0px' : ref.style.maxHeight = ref.scrollHeight + 'px'
    if(this.active) {
      this.$emit('openAccordion')
    } else {
      this.$emit('closeAccordion')
    }
  }

  close() {
    this.active = false
    const ref = this.$refs.content
    if(ref && ref.style) {
      ref.style.maxHeight = '0px'
    }
  }

  @Watch('activeItem', { immediate: true })
  handlerCloseItem(): void {
    if(this.activeItem !== 0 && this.activeItem !== this.itemIndex) {
      this.close()
    }
  }
}
